import { action, observable, computed } from 'mobx';

export default class BiddingStore {
  @observable vm = undefined;

  @computed get history() {
    if (!this.vm || !this.vm.history) {
      return [];
    }
    return this.vm.history
      .map(b => {
        const offer = this.offers.getByBuyerId(b.buyerId);
        if (!offer) {
          return { name: '', ...b };
        }
        return {
          name: `${offer.buyer.buyer_lastName}, ${offer.buyer.buyer_firstName}`,
          ...b,
        };
      })
      .sortBy('createdAt', false);
  }

  @computed get highestBidder() {
    if (!this.vm.highestBidderId) {
      return '';
    }
    const offer = this.offers.getByBuyerId(this.vm.highestBidderId);
    if (!offer) {
      return '';
    }
    return `${offer.buyer.buyer_lastName}, ${offer.buyer.buyer_firstName}`;
  }

  constructor({ offers }) {
    this.offers = offers;
  }

  @action update(data) {
    this.vm = data;
  }

  @action reset() {
    this.vm = undefined;
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/stores/BiddingStore.js